import { TrackedQuery } from '@ih/app/client/shared/interfaces';

export class Sync {
  public static readonly type = '[Notifications] Sync';
  constructor(public readonly trackedQuery: TrackedQuery) {}
}
